import PropTypes from 'prop-types';
import { CloseButton } from 'react-bootstrap';

/**
 * Filter tag component.
 *
 * @param {object} props
 * @param {string} props.filterName - The name of the filter.
 * @param {Function} props.onRemove - Function to run when the close button is clicked.
 */
const FilterTag = ({ filterName, onRemove }) => {
    return (
        <div
            className="d-inline-flex align-items-center border rounded px-2 py-1 me-2"
            style={{ background: 'transparent' }}
        >
            <span>{filterName}</span>
            <CloseButton onClick={onRemove} className="ms-2" />
        </div>
    );
};

FilterTag.propTypes = {
    filterName: PropTypes.string.isRequired,
    onRemove: PropTypes.func.isRequired,
};

export default FilterTag;
